/**
 * 右键：这个目标该不该弹**浏览器自己的**菜单？
 *
 * ## 为什么需要它
 *
 * 真机反馈："窗口中右键会弹出浏览器的默认菜单。能不能给全局所有的窗口区域，
 * 不要让它右键弹出浏览器的默认菜单？"
 *
 * 浏览器菜单里的「另存为图片 / 检查 / 翻译成中文」对画布、标题栏、面板来说
 * 全是噪音，而且它一弹就**盖住**我们自己的菜单（节点图的节点菜单、
 * 窗口头的区域菜单都挂在右键上）。
 *
 * ## 为什么单独一个纯函数
 *
 * 判定里有**唯一一个例外**，而例外是最容易写错的那部分：
 * **可编辑控件里要留着**（`input` / `textarea` / `contenteditable`）——
 * 那里的右键菜单是"粘贴 / 全选 / 拼写"的入口，挡掉它是真的丢功能，
 * 而用户抱怨的从来不是它。抽出来之后可以逐条断言（含"例外不能扩大"）。
 *
 * ⚠️ 不要顺手把例外扩成"所有表单控件"：`<select>` / `<button>` 上没有
 * 浏览器菜单可用的东西，而它们在面板里到处都是 —— 那等于把功能关掉一半。
 */
const EDITABLE_TAGS = new Set(['INPUT', 'TEXTAREA'])

export function suppressNativeContextMenu(target: EventTarget | null): boolean {
  const el = target as (HTMLElement & { isContentEditable?: boolean }) | null
  if (!el || typeof el !== 'object') return true
  const tag = typeof el.tagName === 'string' ? el.tagName.toUpperCase() : ''
  if (EDITABLE_TAGS.has(tag)) return false
  if (el.isContentEditable === true) return false
  return true
}
